import { is } from "immutable";
import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import * as redux from "redux";
import * as Actions from "../../../../actions";
import * as Comp from "../../../../components";
import { ComponentWithValidatedForm } from "../../../../components/validation";
import { CareerCenterJobCategories } from "../../../../domain";
import * as Forms from "../../../../forms";
import * as M from "../../../../models";
import { Api } from "../../../../services/Api";
import { AppState } from "../../../../store";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    api: new Api(state),
    subscribedCategoryIds: state.careerCenter.userSubscriptions.jobPostCategoryIds,
    userGuid: state.auth.data ? (state.auth.data.userGuid || "") : "",
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    notifySuccess: (message: string, icon?: string) => dispatch(Actions.Noti.notifySuccess(message, icon)),
    updateSubscriptions: (categoryIds: number[]) => dispatch(Actions.CareerCenter.updateUserJobSubscriptions(categoryIds)),
});

interface OwnProps {
}

interface ConnectedState {
    api: Api;
    subscribedCategoryIds: number[];
    userGuid: string;
}

interface ConnectedDispatch {
    notifySuccess: (message: string, icon?: string) => void;
    updateSubscriptions: (categoryIds: number[]) => void;
}

interface OwnState {
}

type CombinedProps = OwnProps & ConnectedState & ConnectedDispatch;

class JobAlertsFormComponent extends ComponentWithValidatedForm<CombinedProps, OwnState> {

    public constructor(props: any) {
        super(props);
        const formModel = new Forms.CareerCenter.SubscriptionAlerts();
        this.state = {
            ...this.getInitialState(formModel),
        };
    }

    public componentWillMount() {
        this.updateFormCategories(this.props.subscribedCategoryIds);
    }

    public componentWillReceiveProps(nextProps: Readonly<CombinedProps>) {
        if (!is(this.props.subscribedCategoryIds, nextProps.subscribedCategoryIds))
            this.updateFormCategories(nextProps.subscribedCategoryIds);
    }

    public render() {
        const categories: M.Editors.SelectItem[] = _.orderBy(CareerCenterJobCategories.Values, "sort").map((c) => ({
            id: c.id,
            render: c.name,
            selected: false,
        }));

        return <Comp.Validation.ValidatedForm
            formComponent={this}
            model={this.state.formModel.data}
            onValidSubmit={(model) => this.onSubmit(model)}
            schema={this.state.formModel.rules}
            scrollToErrors={false}
            ref={(ref) => this.form = ref}
        >
            <h2>Job Alerts</h2>

            <p>Update your job subscriptions to receive automated email notifications whenever new jobs become available.</p>

            <Comp.Editors.RadioOrCheckListField formComponent={this} noFieldWrap items={categories} name="categoryIds" type="checkbox" />

            <Comp.Editors.SubmitField noFieldWrap showProcessing={this.state.formProcessing} label="Update" />

        </Comp.Validation.ValidatedForm>;
    }

    private async onSubmit(model: Forms.CareerCenter.SubscriptionAlertsData) {
        this.toggleProcessing(true);

        const body = {
            categoryIds: model.categoryIds,
            user: this.props.userGuid,
        };

        const result = await this.props.api.post<number[]>(Api.endpoints.users.careerCenter.jobSubscription, {
            body: JSON.stringify(body),
        });

        if (result.isSuccess && result.data && Array.isArray(result.data)) {
            await this.props.updateSubscriptions(result.data);
            this.props.notifySuccess("Job alert subscription preferences have been successfully updated.");
        }
        else {
            this.handleValidationErrors([{
                inputName: "categoryIds",
                errors: M.Result.Result.errorsOrMessage(result),
            }]);
        }

        this.toggleProcessing(false);
    }

    private updateFormCategories(categoryIds: number[]) {
        const formModel = this.getFormModel() as Forms.CareerCenter.SubscriptionAlerts;
        formModel.data.categoryIds = categoryIds;
        this.setState({ ...this.state, formModel });
    }
}

export const JobAlertsForm: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(JobAlertsFormComponent);



// WEBPACK FOOTER //
// ./src/containers/user/careerCenter/components/JobAlertsForm.tsx